module.exports = __webpack_public_path__ + "static/media/checkIcon.bc5bc08a.svg";